// extracted by mini-css-extract-plugin
export default {"container":"ModalHeader_container__l8Q5Z","title":"ModalHeader_title__f1ffi","closeOuter":"ModalHeader_closeOuter__vIpqF"};